import { z } from "zod";
import { Conflict } from "@opstel/query/v2/models/conflict";
import type { components } from "@opstel/gen/api/v2";
import { intervalSchema } from "./utils/dateTime";

export const conflictSchema = z.object({
  id: z.uuid(),
  timeInterval: intervalSchema,
  type: z.string().min(1),
  displayDescription: z.string().min(1),
  detectedBy: z.enum(["HIP", "KnoP"]),
}) satisfies z.ZodType<Conflict, components["schemas"]["Conflict"]>;
